import { Stack, Typography } from '@mui/material'
import { ReactNode } from 'react'

interface Props {
  label: ReactNode
  value: ReactNode
}

const SummaryBlock = ({ label, value }: Props) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      spacing={1}
    >
      <Typography variant="subtitle2">
        <strong>{label}</strong>:
      </Typography>
      {value}
    </Stack>
  )
}

export default SummaryBlock
